import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/FormElements/Button";
import Input from "shared/components/FormElements/Input";
import { CheckTimeString } from "shared/util/time";
import { StoreContext } from "shared/context/store-context";
import CustomSelect from "shared/components/FormElements/Select";
import { useForm } from "shared/hooks/form-hook";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TransferServiceRow from "./TransferAnalyzer-TransferServiceRow";
import { VALIDATOR_REQUIRE } from "shared/util/validators";
import GenericCard from "components/ui/cards/GenericCard";

const TransferServices = (props) => {
  const { t } = useTranslation();
  const { driverOptions, drivers } = useContext(StoreContext);
  const [isAddingService, setIsAddingService] = useState(false);

  const [formState, inputHandler] = useForm(
    {
      name: { value: null, isValid: false },
      drivers: { value: null, isValid: true },
      plate: { value: null, isValid: true },
      starttime: { value: "00:01", isValid: true },
      stoptime: { value: "23:59", isValid: true },
      routeClientArrivalTime: {
        value: props.transfertime,
        isValid: true,
      },
    },
    false
  );

  const [plateKey, setPlateKey] = useState(null);

  const addNewService = async () => {
    setIsAddingService(true);
    if (!CheckTimeString(formState.inputs.starttime.value) || !CheckTimeString(formState.inputs.stoptime.value)) {
      window.toast.error(t("transferAnalyzer.services.invalidTimeError"));
      setIsAddingService(false);
      return;
    }

    try {
      await props.addService(
        formState.inputs.name.value,
        formState.inputs.drivers.value,
        formState.inputs.plate.value,
        formState.inputs.starttime.value,
        formState.inputs.stoptime.value,
        formState.inputs.routeClientArrivalTime.value
      );
    } finally {
      setIsAddingService(false);
    }
  };

  const driverChangeHandler = (selectedDrivers) => {
    if (selectedDrivers.length > 0) {
      const currentDriver = drivers.find((driver) => driver.id === selectedDrivers[0]);
      const currentPlate = currentDriver?.plate || "-";
      inputHandler("plate", currentPlate, true);
      setPlateKey(currentPlate);
    } else {
      inputHandler("plate", null, false);
      setPlateKey(null);
    }
  };

  return (
    <div style={{ display: "flex", width: "100%", flexDirection: "column", height: "100%" }}>
      <GenericCard
        title={t("transferAnalyzer.services.addCardTitle")}
        dismissible={false}
        style={{ paddingBottom: "0px", marginBottom: "20px", marginTop: "20px" }}
      >
        <div style={{ display: "flex", gap: "20px", justifyContent: "flex-start", marginTop: "10px", width: "100%" }}>
          <div style={{ width: "400px" }}>
            <Input
              id="name"
              element="input"
              type="text"
              label={t("transferAnalyzer.services.serviceNameLabel")}
              validators={[VALIDATOR_REQUIRE()]}
              errorText={t("transferAnalyzer.services.serviceNameError")}
              onInput={inputHandler}
              dontShowError={true}
            />
          </div>

          <div style={{ width: "400px" }}>
            <CustomSelect
              options={driverOptions}
              id="drivers"
              isMulti={true}
              onInput={inputHandler}
              label={t("transferAnalyzer.services.driversLabel")}
              fireChange={driverChangeHandler}
            ></CustomSelect>
          </div>

          <div style={{ width: "200px" }}>
            <Input
              id="plate"
              key={plateKey}
              element="input"
              type="text"
              label={t("transferAnalyzer.services.plateLabel")}
              validators={[VALIDATOR_REQUIRE()]}
              initialValue={plateKey}
              initialValid={Boolean(plateKey)}
              errorText={t("transferAnalyzer.services.plateError")}
              onInput={inputHandler}
              dontShowError={true}
            />
          </div>
          <div style={{ paddingTop: "30px" }}>
            <Button
              type="button"
              danger
              onClick={addNewService}
              isLoading={isAddingService}
              disabled={!formState.isValid || isAddingService}
            >
              {t("transferAnalyzer.services.addButton")}
            </Button>
          </div>
        </div>
      </GenericCard>
      {/* <div style={{ borderBottom: "2px solid red", width: "100%", marginBottom: "20px", marginTop: "10px" }}></div> */}
      <GenericCard
        title={t("transferAnalyzer.services.listCardTitle")}
        dismissible={false}
        style={{ paddingBottom: "0px", marginBottom: "20px" }}
      >
        <TableContainer
          component={Paper}
          sx={{
            minWidth: 650,
            // marginTop: "20px",
            //paddingBottom: "50px",
            // marginBottom: "20px",
            // paddingTop: "20px",
            height: "100%",
            marginBottom: "20px",
          }}
        >
          <Table
            sx={{
              minWidth: 650,
              width: "100%",
              justifyContent: "center",
              margin: "auto",
              zIndex: -1,
            }}
            aria-label="simple table"
          >
            <TableBody>
              {props.services.map((service, index) => (
                <React.Fragment key={"FragmentList" + service.id}>
                  <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell colSpan={1}>
                      <div style={{ paddingTop: "27px", fontWeight: "bold", fontSize: "16px", width: "5px" }}>
                        {" "}
                        {index + 1}.
                      </div>
                    </TableCell>
                    <TableCell style={{ paddingBottom: "20px", paddingTop: "20px" }} colSpan={6}>
                      <TransferServiceRow
                        key={"ServiceItem" + service.id}
                        school={props.school}
                        service={service}
                        users={service.users
                          .map((su) => props.users.find((u) => u.id === su.id))
                          .filter(Boolean)}
                        // deleteService={props.deleteService}
                        type={props.type}
                        // onDelete={() => RemoveService(service.id)}
                      />
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </GenericCard>
    </div>
  );
};

export default TransferServices;
